import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const body = css`
  padding-inline-start: 0 !important; // Переопределил свойство у <Text> компонента
`
export const disabled = css`
  cursor: not-allowed;
  opacity: 0.5;
`
export const skeleton = css`
  border-radius: ${spacing(0.5)}; // 4px
  opacity: 0.75;
  overflow: hidden;
  position: relative;

  &::before {
    animation: slide 1.5s infinite;
    background: linear-gradient(90deg transparent ${cssTheme.colors.deliveryGrey[100]} transparent);
    block-size: 100%;
    content: '';
    inline-size: 100%;
    inset-block-start: 0;
    inset-inline-start: -100%;
    position: absolute;
  }

  @keyframes slide {
    to {
      transform: translateX(200%);
    }
  }
`
